import React from "react";

import { usePasswordReset } from "./usePasswordReset.tsx";
import PasswordResetUI from "./PasswordReset.ui.tsx";

const PasswordReset: React.FC = () => {
  const PasswordResetProps = usePasswordReset();

  return <PasswordResetUI {...PasswordResetProps} />;
};

export default PasswordReset;
